const Loader = () => {
  return (
    <div className="absolute w-full h-full z-50 flex justify-center items-center bg-white">
      <div className="loader text-primaryLight">Loading...</div>
    </div>
  );
};

export default Loader;
